import mapKnownValues from "@/utils/mapKnownValues";

type AdminReportValue = {
  label: string;
  data: number;
  description: string;
};

export type AdminReportResponse = {
  data: AdminReportValue[];
};

export default class AdminReport {
  values: AdminReportValue[] = [];

  constructor(params: Partial<AdminReport> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: AdminReportResponse) {
    return new AdminReport({ values: response.data });
  }
}
